import createVueApp from '@/common/createApp'

Styxie.Initializers.ReviewsDashboard = {
  index: async(props) => {
    const { default: ReviewsDashboard } = await import('@/vue_widgets/reviews_dashboard/index.vue')
    createVueApp(ReviewsDashboard, { props })
  }
}
